import React from 'react';

import WorksheetStepStatusIcon from 'notebook/worksheets/steps/WorksheetStepStatusIcon';
import {WorksheetStepGroup, WorksheetTaskStatusType} from 'notebook/worksheets/WorksheetConstants';
import getTestProps from 'test/lib/cypress/getTestProps';

import {getSelectedStepControlFlags} from '../util/worksheetSelectedStepControl';
import {extractStepTasksData, SelectStepTasks} from './WorksheetUtils';

interface WorksheetPrinterFriendlyStepsListProps {
  stepGroups: Array<Pick<WorksheetStepGroup, 'name' | 'worksheetSteps'>>;
  isWorksheetPending: boolean;
  selectStepTasks: SelectStepTasks;
}

export default function WorksheetPrinterFriendlyStepsList({
  stepGroups,
  isWorksheetPending,
  selectStepTasks,
}: WorksheetPrinterFriendlyStepsListProps): JSX.Element {
  return (
    <div className="section">
      <hr />
      <h2>Steps</h2>
      {stepGroups.map((group, index) => {
        const steps = group.worksheetSteps.map((step, stepIndex) => {
          const stepTaskData = extractStepTasksData(selectStepTasks(step.tasks));

          const {isSelectedStepActionsLocked} = getSelectedStepControlFlags(
            isWorksheetPending,
            index,
            stepTaskData.status,
            stepGroups.length
          );

          // We want the displayed status of step belonging to a "Run" group  to be `Not Ready`, if the steps in "Pre-run" group
          // are not yet finalized.
          const stepStatus =
            !isSelectedStepActionsLocked && stepTaskData.status
              ? stepTaskData.status
              : WorksheetTaskStatusType.NOT_READY;

          return (
            <div key={`step-${index}-${stepIndex}`} className="valign margin-bottom-0_5em">
              <WorksheetStepStatusIcon viewer={true} status={stepStatus} />
              <span className="margin-left-0_5em">{step.document.name}</span>
            </div>
          );
        });

        return (
          <div
            key={`stepgroup-${index}`}
            {...getTestProps({component: 'WorksheetPrinterFriendlyStepsList', element: 'stepslist'})}
          >
            <h3 className="heading">{group.name}</h3>
            {steps}
          </div>
        );
      })}
    </div>
  );
}
